import { useEffect, useState } from 'react';
import {
  CenterButtonContainer,
  TextBold,
  TextRegular,
} from '../../../styles/GlobalStyledComponents';
import UnknowError from '../../../assets/images/Errors/unknownError.svg';
import Button from '../../../components/Button/Button';
import { colors } from '../../../styles/Colors';
import { useLocation, useNavigate } from 'react-router-dom';
import { ROUTES_PATH } from '../../../constants';
import { loadFromSessionStorage } from '../../../utils/sessionStorageHelper';
import GAnalyticsService from '../../../services/GAnalytics/ganalytics.service';
import dayjs from 'dayjs';
import {
  ImgWrapper,
  ModalImgDiv,
  ModalTextWrapper,
  ModalWrapper,
} from '../FinalModalStyledComponents';
import { TransactionReasonEnum } from '../../../interfaces/Debt';
import { PaymentMethod } from '../../../interfaces/PaymentMethod';

const UnknownError = () => {
  const { red4, white } = colors;
  const entryCo = sessionStorage.getItem('flow');
  const navigate = useNavigate();
  const [initTime] = useState<dayjs.Dayjs>(dayjs());
  const { isVerifyCard } = useLocation().state || sessionStorage.getItem('isVerifyCard') === 'true';

 //Cuando exista el campo categoría en el método de pago seleccionado va a implicar que hemos seleccionado una promoción
  const paymentSelected = loadFromSessionStorage(
    'pepper-user-payment-selected'
  );

  const coPaymentSelected = loadFromSessionStorage(
    'pepper-user-co-payment-selected'
  );

  const sofortPaymentKo = localStorage.getItem('sofortPayment') === 'CANCEL' || false;
  
  useEffect(() => { 
    paymentSelected && paymentSelected.category
      ? GAnalyticsService.saveUsedPromotion(true)
      : GAnalyticsService.saveUsedPromotion(false);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  

  useEffect(() => {
    //Solo en el caso de un intento fallido de pago con la modalidad de transferencias se devuelve a la pantalla de métodos de pago
    if (sofortPaymentKo) {
      sessionStorage.removeItem('pepper-payment-method');
      GAnalyticsService.sendPaymentError(initTime, PaymentMethod.BANK_ACCOUNT);
      navigate(ROUTES_PATH.TYPES_PAYMENTS);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const goToRetry = () => {
    if (isVerifyCard) {
      navigate(ROUTES_PATH.VERIFY_CARD_TPV);
    } else if ((entryCo &&
          ((coPaymentSelected && coPaymentSelected.transaction_reason === TransactionReasonEnum.CPP) 
          || (paymentSelected && paymentSelected.transaction_reason === TransactionReasonEnum.CPP))
          && !loadFromSessionStorage('pepper-payment-plan'))) {
            GAnalyticsService.sendPaymentError(initTime);
            navigate(ROUTES_PATH.ENTRY_CO);    
    } else {
      navigate(ROUTES_PATH.TYPES_PAYMENTS);
    }
  };

  return (
    <ModalWrapper id="unknown-error-page">
      <ImgWrapper id="unknown-error-img-wrapper">
        <ModalImgDiv
          src={UnknowError}
          id="unknown-error-img"
          alt="unknown-error image"
          title="unknown-error image"
          width={''}
          height={''}
        />
      </ImgWrapper>
      <ModalTextWrapper id="unknown-error-title-wrapper">
        <TextBold
          fontSize={24}
          lineHeight={32}
          align="center"
          id="unknown-error-title"
        >
          ¡Ups!
        </TextBold>
      </ModalTextWrapper>
      <ModalTextWrapper id="unknown-error-text-wrapper">
        {isVerifyCard ? (
          <TextRegular
            fontSize={18}
            lineHeight={24}
            id="unknown-error-text"
            color="gray6"
          >
            Ha habido un problema y no se ha podido completar el proceso.
            Inténtalo de nuevo.
          </TextRegular>
        ) : (
          <TextRegular
            fontSize={18}
            lineHeight={24}
            id="unknown-error-text"
            color="gray6"
          >
            Ha habido un problema y no se ha podido completar el pago. Puedes
            intentarlo de nuevo o probar con una opción de pago distinta.
          </TextRegular>
        )}
      </ModalTextWrapper>
      <CenterButtonContainer>
        <Button
          color={white}
          backgroundColor={red4}
          minWidth="280px"
          click={() => goToRetry()}
          id="unknown-error-back-btn"
        >
          <TextBold fontSize={18} color={white} lineHeight={20}>
            Vuelve a intentarlo
          </TextBold>
        </Button>
      </CenterButtonContainer>
    </ModalWrapper>
  );
};

export default UnknownError;
